import {useRef, useEffect, useState} from 'react';
import classNames from 'classnames';
import {useWindowSize} from 'react-use';

import log from 'loglevel';

const AutoHeightEmbed = props => {
  const {height:windowHeight} = useWindowSize();
  const embed = useRef();

  const [height, updateHeight] = useState(0);

  useEffect(() => {
    updateHeight( windowHeight - (embed.current.getBoundingClientRect().top + window.scrollY) );
  }, [windowHeight]);

  return (
    <div ref={embed} className={classNames("auto-height-embed", props.className)} style={{height:height}}>
      {props.children}
    </div>
  );
};

export default React.memo(AutoHeightEmbed);
